import React, { useEffect, useRef, useState } from 'react'
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import '../../../common/rsuite-datepicker.css'
import Select, { StylesConfig } from 'react-select';
import { format } from 'date-fns';
import fetchAPI from '../../../common/fetchAPI';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { resetSelectedRecordObjectInState, getAccountWebHookReceiverLogAsync,setDateRangeValue,setOptionStatusValue,setOptionWebHookEventTypeValue,setSortConfig } from './WebHookReceiverLogSlice';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import DatePickerRanges from '../../../common/DatePickerRanges';


const WebHookReceiverLogOffCanvas = (props: any) => {
    const {t} = props;
    const dispatch = useAppDispatch();
    const { isReload, currentPage, pageSize, start, search,columnIndex,direction } = useAppSelector((state) => state.webHookReceiverLog);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const { maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat} = useAppSelector((state) => state.globalState);
    const [statusArray, SetstatusArray] = useState<any | ''>([]);
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>({ value: 'All', label: 'All' });
    const [WebhookEventArray, SetWebhookEventArray] = useState<any | ''>([]);
    const [selectedWebhookEventOptionDropDown, setSelectedWebhookEventOptionDropDown] = useState<{ [object: string]: any }>({ value: 'All', label: 'All' });
    const [displayedRange, setDisplayedRange] = useState(t('Please Select Date Range'));

    useEffect(() => {
        let Status = [
            { value: 'All', label: 'All' },
            { value: 'success', label: 'Success' },
            { value: 'in progress', label: 'In Progress' },
            { value: 'fail', label: 'Fail' }
        ]
        SetstatusArray(Status);
    }, [])

    const getWebhookEventAsync = async () => {
        const response = await fetchAPI("api/V2/Logs/WebhookEventTypeCaptionsForDropDown/", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        json.Data.items.map((item: any) => {
            item.value = item.id;
            item.label = item.text;
            delete item.id;
            delete item.text;
        });
        json.Data.items.unshift({ value: 'All', label: 'All' })

        SetWebhookEventArray(json.Data.items);
    }

    useEffect(() => {
        getWebhookEventAsync();
    }, [])

    const handleDateRangeChange = (value: any) => {
        // setStartDate(value[0]);
        // setEndDate(value[1]);
        // dispatch(setDateRangeValue({startDate:value[0].toISOString(),endDate:value[1].toISOString()}))
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // setStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        // setEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        // dispatch(setDateRangeValue({startDate:dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate:dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString())}));
        setStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
        dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
    };

    const handleChange = (data: any) => {
        const { value, label } = data;
        setSelectedOptionDropDown({ value: value, label: label });
        dispatch(setOptionStatusValue({ value: value, label: label }));
    };

    const handleWebhookEventChange = (data: any) => {
        const { value, label } = data;
        setSelectedWebhookEventOptionDropDown({ value: value, label: label });
        dispatch(setOptionWebHookEventTypeValue({ value: value, label: label }));
    };

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        dispatch(resetSelectedRecordObjectInState());

        //let SearchParamsValues = `${selectedClientNameOptionDropDown.value},${selectedEmployee.value},${selectedProjectOptionDropDown.value},${selectedProjectTaskOptionDropDown.value},${selectedApprovedOptionDropDown.value},${false},
        //${moment(startDate).format(dateInsertionFormat)},${moment(endDate).format(dateInsertionFormat)},${selectedClientNameOptionDropDown.label},${selectedEmployee.label},${selectedProjectOptionDropDown.label},${selectedProjectTaskOptionDropDown.label}`;
       
        //dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: search }));
        
        let SearchParamsValues = `${selectedOptionDropDown.value},${moment(startDate).format(dateInsertionFormat)},${moment(endDate).format(dateInsertionFormat)},${selectedWebhookEventOptionDropDown.value}`;
        dispatch(getAccountWebHookReceiverLogAsync({ currentPage: currentPage, pageSize: pageSize, start: start, order: columnIndex, orderDir: direction, SearchParamsValues: SearchParamsValues, search: " " }));
        // dispatch(getAccountWebHookReceiverLogAsync({ currentPage: 1, pageSize: pageSize, start: start, order: columnIndex, orderDir: direction, SearchParamsValues: SearchParamsValues, search: search }));
        
    };

    const handleResetFiltersOnClickEvent = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setSelectedOptionDropDown({ value: 'All', label: 'All' });
        setSelectedWebhookEventOptionDropDown({ value: 'All', label: 'All' });
        dispatch(resetSelectedRecordObjectInState());
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    };


    return (

        <>
            <div className='card-body'>
                <div className='row' >
                    <div className='col-md-12'>
                    <label className="form-label fs-7 fw-normal mb-2">
                        {/* {t('Date Range')} */}
                        {getValueFromResource('Date Range',dispatch, t)}
                        </label>
                    <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges() }
                                value={[startDate, endDate]}
                                // placeholder='Please Select Date Range'
                                placeholder={displayedRange}
                                character={' - '}
                                cleanable={false}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            >
                            </DateRangePicker>
                        </div>
                    </div>
                    <div className='col-md-12 mt-6'>
                       <label className="form-label fs-7 fw-normal mb-2">
                        {/* {t('Status')} */}
                        {getValueFromResource('Status',dispatch, t)}

                        </label>
                        <div>
                            <Select
                                 placeholder={t('Select')}
                                value={selectedOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleChange}
                                options={statusArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                            
                        </div>
                    </div>
                </div>
                <div className='row' >
                    <div className='col-md-12 mt-6'>
                    <label className="form-label fs-7 fw-normal mb-2">{t('Webhook Event Type')}</label>
                        <div>
                            <Select
                                value={selectedWebhookEventOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleWebhookEventChange}
                                options={WebhookEventArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                        </button>
                        <button 
                            className="btn btn-secondary btn-sm me-2 fs-7"
                            type='button'
                            data-kt-element='send'
                            onClick={handleResetFiltersOnClickEvent}
                        >
                            {/* {t('Reset Filters')} */}
                            {getValueFromResource('Reset Filters',dispatch, t)}

                        </button>
                        <button 
                            className="btn btn-primary btn-sm fs-7"
                            type='button'
                            data-kt-element='send'
                            onClick={handleApplyFilterOnClickEvent}
                        >
                            {/* {t('Apply Filters')} */}
                            {getValueFromResource('Apply Filters',dispatch, t)}

                            
                        </button>
                    </div>
                </div>
            </div>

        </>

    )

}

export default WebHookReceiverLogOffCanvas



// const TaskOffCanvas: FC = () => (

//   <div

//     //id='kt_drawer_chat'

//     id='rameez'

//     className='bg-body'

//     data-kt-drawer='true'

//     data-kt-drawer-name='chat'

//     data-kt-drawer-activate='true'

//     data-kt-drawer-overlay='true'

//     data-kt-drawer-width="{default:'300px', 'md': '500px'}"

//     data-kt-drawer-direction='end'

//     data-kt-drawer-toggle='#kt_drawer_example_basic_button_one'

//     data-kt-drawer-close='#kt_drawer_example_advanced_close'

//   >

//     <div className='card w-100 rounded-0' id='kt_drawer_chat_messenger'>

//       <div className='card-header pe-5' id='kt_drawer_chat_messenger_header'>

//         <div className='card-title'>

//           <div className='d-flex justify-content-center flex-column me-3'>

//             <a href='#' className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>

//               Brian Cox

//             </a>

//             <div className='mb-0 lh-1'>

//               <span className='badge badge-success badge-circle w-10px h-10px me-1'></span>

//               <span className='fs-7 fw-bold text-gray-400'>Active</span>

//             </div>

//           </div>

//         </div>

//         <div className='card-toolbar'>

//           <div className='me-2'>

//             <button

//               className='btn btn-sm btn-icon btn-active-light-primary'

//               data-kt-menu-trigger='click'

//               data-kt-menu-placement='bottom-end'

//               data-kt-menu-flip='top-end'

//             >

//               <i className='bi bi-three-dots fs-3'></i>

//             </button>

//           </div>

//           <div className='btn btn-sm btn-icon btn-active-light-primary' id='kt_drawer_chat_close'>

//             <KTIcon iconName='cross' className='fs-2' />

//           </div>

//         </div>

//       </div>

//     </div>

//   </div>

// )

// export {TaskOffCanvas}

